var start = null
var scenes = []

function addScene(id, input, animate, onActivate, onDeactivate) {
    let scene = {
        id: id,
        input: input,
        animate: animate,
        active: false,
        onActivate: onActivate ? onActivate : () => {},
        onDeactivate: onDeactivate ? onDeactivate : () => {},
        handleInput: input ? input : () => {},
        handleAnimationFrame: animate ? animate : () => {},
        activate: () => activateScene(id),
        deActivate: () => deActivateScene(id)
    }
    scenes.push(scene)
    return scene
}

function activateScene(id) {
    let index = scenes.findIndex(s => s.id === id)
    if (index > -1) {
        scenes[index].active = true
        scenes[index].onActivate()
    }
}

function deActivateScene(id) {
    let index = scenes.findIndex(s => s.id === id)
    if (index > -1) {
        scenes[index].active = false
        scenes[index].onDeactivate()
    }
}

function handleInput(input, amt, released) {
    scenes.filter(f => f.active).forEach(scene => {
        scene.handleInput(input, amt, released)
    })
}

function handleAnimationFrame(timeStamp) {
    window.requestAnimationFrame(handleAnimationFrame)
    if (start === null) {
        start = timeStamp - 16 // If we don't do this, the first frame timestamp is too long so we fake 60fps by subtracting 16
    }
    let delta = timeStamp - start;
    start = timeStamp;
    scenes.filter(f => f.active).forEach(scene => {
        scene.handleAnimationFrame(delta)
    })
}

export { handleAnimationFrame, handleInput, addScene, activateScene, deActivateScene }